import { render, staticRenderFns } from "./voiceRecorder.vue?vue&type=template&id=252ec7a4&scoped=true&"
import script from "./voiceRecorder.vue?vue&type=script&lang=ts&"
export * from "./voiceRecorder.vue?vue&type=script&lang=ts&"
import style0 from "./voiceRecorder.vue?vue&type=style&index=0&id=252ec7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ec7a4",
  null
  
)

export default component.exports